import { render, staticRenderFns } from "./CustomizedComments.vue?vue&type=template&id=c2e7c850&scoped=true"
import script from "./CustomizedComments.vue?vue&type=script&lang=js"
export * from "./CustomizedComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e7c850",
  null
  
)

export default component.exports